import { Module } from 'vuex';
import { WorkflowState } from './type'
import { RootState } from '@/store/type'
import state from './state';
import getters from './getters';
import actions from './actions';
import mutations from './mutations';

export const workflow: Module<WorkflowState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};